import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "image-viewer" }
const _hoisted_2 = ["src"]

import { ref, computed, watch } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'view-image-list',
  props: {
    images: {},
    selected: {}
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const currentIndex = ref<number>(props.selected ?? 0);

watch(
  () => props.selected,
  (val) => {
    if (val !== null) {
      currentIndex.value = val;
    }
  }
);

const currentImage = computed(() => props.images[currentIndex.value] ?? null);

function close() {
  emit("close");
}

function prev() {
  if (currentIndex.value > 0) {
    currentIndex.value--;
  }
}

function next() {
  if (currentIndex.value < props.images.length - 1) {
    currentIndex.value++;
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      onClick: close,
      class: "close-btn"
    }, "✕"),
    (currentIndex.value > 0)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          onClick: prev,
          class: "prev-btn"
        }, "‹"))
      : _createCommentVNode("", true),
    _createElementVNode("img", {
      src: currentImage.value,
      alt: "Imagem"
    }, null, 8, _hoisted_2),
    (currentIndex.value < __props.images.length - 1)
      ? (_openBlock(), _createElementBlock("button", {
          key: 1,
          onClick: next,
          class: "next-btn"
        }, " › "))
      : _createCommentVNode("", true)
  ]))
}
}

})